import React from 'react'
import { Link } from 'react-router-dom'
import { func, bool, string } from 'prop-types'

const NavLink = ({ open, setOpen, children, path, onClick }) => {
  return (
    <Link
      onClick={e => {
        setOpen(!open)
        onClick(e)
      }
      }
      className='tdn'
      to={path}>
      <div
        className='c-black pt10 pb10'
      >
        {children}  
      </div>
    </Link>
  )
}

const MobileHeaderItem = ({ children, path, open, setOpen, onClick }) => {
  return(
    <div className='curp'>
      {open ? 
        <div>
          <NavLink path={path} open={open} setOpen={setOpen} onClick={onClick}>
            {children}
          </NavLink>
          <div className='h1 bgc-darkgray mauto' /> 
        </div>: null
      }
    </div>  
  )
}

export default MobileHeaderItem

MobileHeaderItem.propTypes = {
  children: string,
  path: string,
  open: bool,
  setOpen: func,
  onClick: func
}
